// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-ScrollBar-module--cls1--2rgoq","cls2":"styles-ScrollBar-module--cls2--14b15 styles-ScrollBar-module--cls1--2rgoq"};